import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './i18n/LanguageContext';
import Header from './components/Header';
import Footer from './components/Footer';
import DerrDigitalHomepage from './pages/DerrDigitalHomepage';
import DerrDigitalKontaktseite from './pages/DerrDigitalKontaktseite';
import Impressum from './pages/Impressum';
import AboutUs from './pages/AboutUs';
import Datenschutz from './pages/Datenschutz';
import ScrollToTop from './components/ScrollToTop';
import CookieBanner from './components/CookieBanner/CookieBanner';
import References from './pages/DerrDigitalReferences';
import AllSolutions from './pages/AllSolutionsPage';
import ChatBot from './components/Chatbot/Chatbot';
import AGB from './pages/DerrDigtialAGB';
import OrderPage from './pages/DerrDigitalBookingPage';
import ClientPreview from './pages/ClientPreview';
import AcademyHome from './pages/Academy/AcademyHome';
import SqlAcademy from './pages/Academy/SqlAcademy';
import CsharpAcademy from './pages/Academy/CsharpAcademy';
import ShopPage from './pages/ShopPage';
import AdminDashboard from './pages/AdminDashboard';


import BlogNachhaltigkeit from './Blogarticle/BlogNachhaltigkeit';
import DerrDigitalBlog from './pages/DerrDigitalBlog';
import BlogBandscheibenvorfall from './Blogarticle/BlogBandscheiben';
import BlogFutureMobility from './Blogarticle/BlogFutureMobility';
import BlogKi from './Blogarticle/BlogKi';
import BlogProxmox from './Blogarticle/BlogProxmox';
import BlogWebsite from './Blogarticle/BlogWebsite';

// Der Haupt-App-Komponent
export default function App() {
  const [darkMode, setDarkMode] = useState(false);

  // Theme-Wechsel bei Seitenladung basierend auf System-Präferenz
  useEffect(() => {
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    setDarkMode(prefersDark);
  }, []);

  // Global overscroll background — prevents white flash at top/bottom
  useEffect(() => {
    const color = darkMode ? '#0a0a0f' : '#f8faff';
    document.documentElement.style.background = color;
    document.body.style.background = color;
  }, [darkMode]);

  // Theme-Wechsel Funktion
  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
  };

  return (
    <LanguageProvider>
    <Router>
      <ScrollToTop/>
      <Routes>

        {/* ── Standalone (kein Header/Footer/Chatbot) ── */}
        <Route path="/preview" element={<ClientPreview darkMode={darkMode} />} />
        <Route path="/admin" element={<AdminDashboard />} />

        {/* ── Haupt-Shell ── */}
        <Route path="/*" element={
          <div style={{ minHeight: '100vh', background: darkMode ? '#0a0a0f' : '#f8faff', color: darkMode ? '#fff' : '#0f0f1a' }}>
            <Header darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
            <main>
              <Routes>
                <Route path="/" element={<DerrDigitalHomepage darkMode={darkMode} />} />
                <Route path="/kontakt" element={<DerrDigitalKontaktseite darkMode={darkMode} />} />
                <Route path="/impressum" element={<Impressum darkMode={darkMode} />} />
                <Route path="/about" element={<AboutUs darkMode={darkMode} />} />
                <Route path="/datenschutz" element={<Datenschutz darkMode={darkMode} />} />
                <Route path="/referenzen" element={<References darkMode={darkMode} />} />
                {/* /allsolutions + /order temporarily disabled */}
                <Route path='/agb' element={<AGB darkMode={darkMode}/>}/>

                {/* Shop */}
                <Route path="/shop" element={<ShopPage darkMode={darkMode} />} />

                {/* Academy */}
                <Route path="/academy" element={<AcademyHome darkMode={darkMode} />} />
                <Route path="/academy/sql" element={<SqlAcademy darkMode={darkMode} />} />
                <Route path="/academy/csharp-patterns" element={<CsharpAcademy darkMode={darkMode} />} />

                {/* Blog */}
                <Route path="/blog" element={<DerrDigitalBlog darkMode={darkMode} />} />
                <Route path="/blog/1" element={<BlogBandscheibenvorfall darkMode={darkMode} />} />
                <Route path="/blog/2" element={<BlogProxmox darkMode={darkMode} />} />
                <Route path="/blog/3" element={<BlogWebsite darkMode={darkMode} />} />
                <Route path="/blog/4" element={<BlogKi darkMode={darkMode} />} />
                <Route path="/blog/5" element={<BlogFutureMobility darkMode={darkMode} />} />
                <Route path="/blog/6" element={<BlogNachhaltigkeit darkMode={darkMode}/>}/>
              </Routes>
            </main>
            <Footer darkMode={darkMode} />
            <CookieBanner darkMode={darkMode} />
            <ChatBot darkMode={darkMode}/>
          </div>
        } />

      </Routes>
    </Router>
    </LanguageProvider>
  );
}